module.exports = __webpack_public_path__ + "img/1_5_izbove.16eb9e53.jpg";